export default import.meta.ROLLUP_FILE_URL_HqlQAyR7AjfTdiD9fZsh0w